import {Box, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MobileGallery from "./MobileGallery";
import {accountStore} from "../../Stores/AccountStore";
import MobileEditBar from "./MobileEditBar";
import ContactOwner from "./ContactOwner";
import React from "react";
import { conditionMap } from "./Post";
import Column from "../Common/Column";
import Chat from "../Chat/Chat";
import {formatNumber, GetCustomFilterLabels} from "../../Utilities/postUtils";
import {timestampToDateTime} from "../../Utilities/dateUtils";
import {Ad} from "../Ads/Ad";
import {bannerStore} from "../../Stores/BannerStore";
import {LinkSanitizerWrapper} from "./LinkSanitizerWrapper";
import {categoryStore} from "../../Stores/CategoryStore";
import Space from "../Common/Space";
import {PostFilters} from "./PostFilters";
import Row from "../Common/Row";

export const PostMobile = ({
    loading,
    isMyPost,
    onDeactivate,
    onActivate,
    onDelete,
    scrollToMessageArea,
    post
}) => {
    const bannerLocation = "M3"
    const banner = bannerStore.banners[bannerLocation];
    const aspectRatio = "3/1";
    const category = categoryStore.categoryList.find(category => category.id == post.CategoryId);
    const levels = post.Category.levels

    const filters = [
        {label: "Tilstand", value: conditionMap[post.Condition]},
        {label: "Kategori", value: levels[`lvl${levels.lvls}`].name},
        ...((post.CustomFilters || [])
            .map(filter => {
                const labels = GetCustomFilterLabels(filter, category?.customFilters);
                return labels ? {label: labels.typeLabel, value: labels.valueLabel} : null;
            })
            .filter(Boolean))
    ];

    return <Stack>
        <Column>
            {/* Title */}
            <Typography sx={{
                fontWeight: 'bold',
                fontSize: '30px',
                wordWrap: "break-word",
                lineHeight: '35px',
            }}>
                {post.Heading}
            </Typography>

            <Row sx={{marginBottom: "10px"}}>
                {/* Price */}
                <Typography
                    alignItems="flex-start"
                    sx={{fontSize: '24px'}}
                >
                    {formatNumber({value: post.Price.toString()})} kr.
                </Typography>

                <Space width={"10px"}/>

                {/* Date */}
                <Stack
                    spacing={1}
                    direction="row"
                    alignItems="center"
                    sx={{color: "#474747"}}
                >
                    <CalendarMonthIcon fontSize="small"/>
                    <Typography>{timestampToDateTime(post.CreationTime)}</Typography>
                </Stack>
            </Row>
        </Column>

        <MobileGallery gallery={post.Images}/>

        {!loading && isMyPost && accountStore.logged && (
            <Box mt={2}>
                <MobileEditBar
                    handleDeactivatePost={onDeactivate}
                    handleActivatePost={onActivate}
                    handleDeletePost={onDelete}
                    post={post}
                />
            </Box>
        )}
        <Box mt={2}>
            <PostFilters sx={{paddingTop: "10px"}} filters={filters} />
            {/*<Space height="10px"/>*/}
        </Box>
        <Box mt={2}>
            <LinkSanitizerWrapper text={post.Body} postId={post.PostId} />
        </Box>

        <Space height="30px"/>

        <Box mt={1}>
            <ContactOwner scrollToMessageArea={scrollToMessageArea} sx={{padding: "10px 0"}} post={post}/>
        </Box>
        <Box mt={1}>
            <Ad
                banner={banner}
                aspectRatio={aspectRatio}
            />
        </Box>

        <Space height="10px"/>

        <Box sx={{p: 1, borderRadius: 1}} id="postMessages">
            <Chat post={post}/>
        </Box>
    </Stack>
}